import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-get-app-faq',
  templateUrl: './get-app-faq.component.html',
  styleUrls: ['./get-app-faq.component.scss'],
})
export class GetAppFaqComponent implements OnInit {
  isVisible = false;
  @Input() className: string;
  step = 1;
  ngOnInit(): void {}
  nextStepHandler(): void {
    if (this.step < 5){
        this.step += 1;
    }
  }
  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  handleOk(): void {
    this.isVisible = false;
  }

}
